// extracted by mini-css-extract-plugin
export default {"button":"common-components-configurable-wizards-ResultWizardStep-ResultWizardStep__button--qN3pC"};